import { makeStyles } from "@material-ui/core";
export const useStyles = makeStyles((theme) => ({
ShareIcon: {
color: theme.palette.primary.main,
width: theme.spacing(4.38),
height: theme.spacing(4.38),
cursor: "pointer",
},
}));
